import { render, staticRenderFns } from "./ChangPssword.vue?vue&type=template&id=bae52eb0&scoped=true&"
import script from "./ChangPssword.vue?vue&type=script&lang=js&"
export * from "./ChangPssword.vue?vue&type=script&lang=js&"
import style0 from "./ChangPssword.vue?vue&type=style&index=0&id=bae52eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae52eb0",
  null
  
)

export default component.exports